export enum IdCardType {
    PASSPORT = 'PASSPORT', NATIONAL_ID_CARD = 'NATIONAL_ID_CARD'
}